import React from "react";
import { Input } from "antd";

type Field = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  width?: number;
};

type TableSearchBarProps = {
  fields: Field[];
  children?: React.ReactNode;
};
const tableSearchBarStyles = {
  container: {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "10px",
    alignItems: "center",
  },
  input: (width: number = 200) => ({ width }),
};

const TableSearchBar: React.FC<TableSearchBarProps> = ({
  fields,
  children,
}) => (
  <div style={tableSearchBarStyles.container}>
    {fields.map((field, idx) => (
      <Input
        key={`field-${field.placeholder}-${idx}`}
        placeholder={field.placeholder}
        value={field.value}
        onChange={(e) => field.onChange(e.target.value)}
        style={tableSearchBarStyles.input(field.width)}
        aria-label={field.placeholder}
      />
    ))}
    {children}
  </div>
);

export default TableSearchBar;
